import { format } from 'date-fns'
import PropTypes from 'prop-types'
import { kuiperClassNames } from '@opallabs/kuiper'
import { dateAdjustedForTimezone } from '@opallabs/lambda'
import { spacingParams } from '../../constants'

const { EXPANDED_TITLE_THRESHOLD } = spacingParams

const MomentDetails = ({ moment, classPrefix, children }) => {
  const expandedTitle = moment.title.length >= EXPANDED_TITLE_THRESHOLD
  const getMomentDateString = () => {
    const pattern = 'MMM d'
    const date = dateAdjustedForTimezone(moment.scheduled_at)
    const endDate = dateAdjustedForTimezone(moment.scheduled_end_at)
    let formattedDate = format(new Date(date), pattern)
    formattedDate = formattedDate.concat(
      ` - ${format(new Date(endDate), pattern)}`
    )
    return formattedDate
  }

  const renderDate = () => (
    <div className={kuiperClassNames('momentCard-momentDate')}>
      <p>{getMomentDateString()}</p>
    </div>
  )

  const getInfoClassnames = () => {
    const classNames = [`${classPrefix}-info`, 'popover-trigger']
    if (moment.scheduled_end_at) {
      classNames.push('showDate')
    }
    if (expandedTitle) {
      classNames.push('expanded-title')
    }
    return classNames
  }

  return (
    <div className={kuiperClassNames(...getInfoClassnames())}>
      {children}
      <div
        aria-live="polite"
        className={kuiperClassNames(
          `${classPrefix}-momentTitle${expandedTitle ? ' expanded-title' : ''}`
        )}
      >
        <p>{moment.title}</p>
      </div>
      {moment.scheduled_end_at ? renderDate() : null}
    </div>
  )
}

MomentDetails.propTypes = {
  children: PropTypes.node,
  classPrefix: PropTypes.string,
  moment: PropTypes.object,
}

export default MomentDetails
